<template>
  <v-form ref="promotionForm" v-model="valid">
    <v-layout style="width: 100%" row wrap>
      <v-flex xs12 pl-2>
        <v-layout pt-2 class="field-padding" row wrap>
          <v-flex xs6 md3 px-2>
            <v-text-field
              :error-messages="errorForField('name')"
              :rules="promotionRules.name"
              maxlength="50"
              v-model="promotion.name"
              label="Name"
              @input="resetError('name')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md5 px-2>
            <v-text-field
              :error-messages="errorForField('description')"
              :rules="promotionRules.description"
              maxlength="1000"
              v-model="promotion.description"
              label="Description"
              @input="resetError('description')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('user_description')"
              :rules="promotionRules.user_description"
              maxlength="1000"
              v-model="promotion.user_description"
              label="Description for User"
              @input="resetError('user_description')"
              :disabled="disabled"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex pt-2 class="field-padding" xs12 pl-2>
        <v-divider class="mx-1"></v-divider>
        <v-layout pt-2 row wrap>
          <v-flex xs6 md4 px-2>
            <DateTimeInput
              :error-messages="errorForField('start_date')"
              :rules="promotionRules.start_date"
              v-model="promotion.start_date"
              :content="promotion.start_date"
              label="Start Date"
              @input="resetError('start_date')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <DateTimeInput
              :error-messages="errorForField('end_date')"
              :rules="promotionRules.end_date"
              v-model="promotion.end_date"
              :content="promotion.end_date"
              label="End Date"
              @input="resetError('end_date')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('expiry_time_minutes')"
              :rules="promotionRules.expiry_time_minutes"
              v-model="promotion.expiry_time_minutes"
              type="number"
              step="1"
              label="Expiry Time"
              hint="Enter expiry time in minutes"
              @input="resetError('expiry_time_minutes')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('code')"
              :rules="promotionRules.code"
              v-model="promotion.code"
              step="1"
              label="Code"
              hint="Code"
              @input="resetError('code')"
              :disabled="disabled"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import DateTimeInput from "@/components/widget/input/DateTimeInput.vue";

export default {
  name: "external_promotion_form",
  components: {
    DateTimeInput
  },
  props: {
    promotion: Object,
    //discountTypes: Array,
    //costAbsorbers: Array,
    errors: { type: Object, default: () => {} },
    disabled: Boolean
  },
  data: function() {
    return {
      valid: false,
      promotionRules: {
        name: [
          v => !!v || "Name is required",
          v => (v && v.length <= 50) || "Name cannot exceed 8 characters"
        ],
        description: [
          v => !!v || "Description is required",
          v =>
            (v && v.length <= 1000) ||
            "Description cannot exceed 1000 characters"
        ],
        user_description: [
          v => !!v || "Description for user is required",
          v =>
            (v && v.length <= 1000) ||
            "Description for user cannot exceed 1000 characters"
        ],
        start_date: [v => !!v || "Start date is required"],
        end_date: [v => !!v || "End date is required"],
        expiry_time_minutes: [v => !!v || "Code lifespan is required"],
        code: [
          v => !!v || "Code is required",
          v => (v && v.length <= 50) || "Code cannot exceed 50 characters"
        ]
      }
    };
  },
  methods: {
    errorForField: function(field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function(field) {
      try {
        switch (field) {
          case "start_date":
            this.errors["end_date"] = "";
            break;
          case "end_date":
            this.errors["start_date"] = "";
            break;
        }
        if (this.errors[field] != []) {
          this.errors[field] = "";
        }
      } catch (err) {
        console.log(err);
      }
    },
    validateForm: function() {
      this.$refs.promotionForm.validate();
    }
  },
  watch: {
    disabled: function() {
      this.$refs.promotionForm.reset();
    },
    valid: function() {
      this.$emit("validityChange", this.valid);
    }
  }
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>